import { LabMDM } from "./lab";

//this model is used to add the kit
export class KitsDTO {
    _id : string;
    kitName : string;
    lab : LabMDM;
    kitType : string;
    requiredMaterials : string;
    swabRestriction : string[]=[];
    channel1Gene : string;
    channel1File : string;
    channel1Dye : string;
    channel2Gene : string;
    channel2File : string;
    channel2Dye : string;
    channel3Gene : string;
    channel3File : string;
    channel3Dye : string;
    channel4Gene : string;
    channel4File : string;
    channel4Dye : string;
    channel5Gene : string;
    channel5File : string;
    channel5Dye : string;
    runProtocol : string;
    version : number;
    chemicalInfoWithLotNos : any;
    chemicalInfoWithCpValues : any;
    labId : string;
    dominantChannel:string;
    machineType: string;
    processingTime: Map<string, number>;
}
